import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {type ICategory} from '../schema';
import {getResponseResults} from '@netx/core-next/utils/api';

/**
 * `getCategoryObjects` request params
 * (what is used to send to server)
 */
export interface GetCategoryObjectsRequestOptions {
	ids: number[];
}

/**
 * `getCategoryObjects` request
 * (what gets sent to the server)
 */
export type GetCategoryObjectsRequest = [
	GetCategoryObjectsRequestOptions['ids'],
];

/**
 * `getCategoryObjects` response
 * (what comes back from the server)
 */
export type GetCategoryObjectsResponse =
	SuccessResponse<GetCategoryObjectsResult>;

/**
 * `getCategoryObjects` result
 * (what is utilized from the server response)
 */
export type GetCategoryObjectsResult = ICategory[];

export const getCategoryObjectsEndpoint = 'getCategoryObjects';

/**
 * Autolist categories
 * @param fetchParams Fetch params
 */
export const getCategoryObjects = async (
	{ids}: GetCategoryObjectsRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetCategoryObjectsRequest = [ids];

	return client
		.post<GetCategoryObjectsResponse>(
			getCategoryObjectsEndpoint,
			requestParams,
			{signal},
		)
		.then(getResponseResults);
};
export default getCategoryObjects;
